const config = {
    'basicInfo': {
        'bigData-btn-tf-search': '工作台,基础信息,银行账户,查询',
        'bigData-btn-tf-add': '工作台,基础信息,银行账户,新增',
        'bigData-btn-tf-change': '工作台,基础信息,银行账户,更新',
        'bigData-btn-tf-personPay': '工作台,基础信息,银行账户,个人注册美的付',
        'bigData-btn-tf-legalPay': '工作台,基础信息,银行账户,法人注册美的付',
        'bigData-btn-tf-del': '工作台,基础信息,银行账户,删除',
        'bigData-btn-qualification-download': '工作台,基础信息,资质信息,下载附件',
    },
    'personInfo': {
        'bigData-btn-search': '工作台,人员账号管理,,人员账号管理-查询'
    },
    'driverInfo': {
        'bigData-btn-search': '工作台,司机管理,,司机管理-查询',
        'bigData-btn-data-desensitization': '工作台,司机管理,,司机管理-涉密字段查看'
    },
    'vehicleInfo': {
        'bigData-btn-search': '工作台,车辆管理,,车辆管理-查询'
    }
};
export default config;
